import * as React from 'react';
import { FilterContext } from './FilterContext';
import { HeaderFilterBar } from './HeaderFilterBar';

interface Props {
    availableFilters: string[];
    renderHeaderElement: (key: string) => React.ReactNode | undefined;
    isSticky?: boolean;
    renderFilters: (selectedFilter: string | null, setSelectedFilter: (query: string | null) => void) => React.ReactNode | undefined;
    renderSearchFilter?: (selectedFilter: string | null, setSelectedFilter: (query: string | null) => void) => React.ReactNode | undefined;
}

export const FilterBar = (props: Props) => {
    const [selectedFilter, setSelectedFilter] = React.useState<null | string>(null);

    return (
        <FilterContext.Provider
            value={{
                availableFilters: props.availableFilters,
                isSticky: props.isSticky,
                selectedFilter,
                setSelectedFilter,
            }}
        >
            {props.renderSearchFilter && props.renderSearchFilter(selectedFilter, setSelectedFilter)}
            <HeaderFilterBar renderHeaderElement={props.renderHeaderElement} />
            {props.renderFilters(selectedFilter, setSelectedFilter)}
        </FilterContext.Provider>
    );
};
